import {
  DebugFloatingButton,
  DebugProvider,
  ProfileProvider,
  useAuth,
  useFlagMatch,
} from '@pm/core';
import { lazy } from 'react';
import MaintenancePage from '../pages/MaintenancePage';

const AuthAppLazy = lazy(() => import('./AuthApp'));
const InauthAppLazy = lazy(() => import('./InauthApp'));

const AppInner = () => {
  const isMaintenanceEnabled = useFlagMatch({
    flag: 'maintenance',
    defaultValue: false,
  });
  const { isLoggedIn } = useAuth();

  if (isMaintenanceEnabled) {
    return <MaintenancePage />;
  }

  if (isLoggedIn) {
    return (
      <ProfileProvider>
        <AuthAppLazy />
      </ProfileProvider>
    );
  }

  return <InauthAppLazy />;
};

const App = () => (
  <DebugProvider>
    <AppInner />
    <DebugFloatingButton />
  </DebugProvider>
);

export default App;
